import dayjs from "dayjs";
import clusters from "../data/response/cluster_response.json";

export async function fetchClusters() {

    const features = clusters.map((data, index) => {
        return {
            id: index + 1,
            type: "Feature",
            properties: {
                displayMessage: `Cluster Id ${data.id}`,
            },
            geometry: {
                type: "Polygon",
                coordinates: data.buffer_geom.coordinates,
            },
        };
    });

    
     console.log("featues", features);
      console.log("data", clusters);

  return {
    type: "FeatureCollection",
    features,
  };
}
